import { render, staticRenderFns } from "./MSearchModel.vue?vue&type=template&id=ebb44f9e&"
import script from "./MSearchModel.vue?vue&type=script&lang=js&"
export * from "./MSearchModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports